import { ICellRendererParams } from "ag-grid-community";
import { PayorFormComponent } from "./payor-form-management.component";

export const lcdColumnConfig = (context: PayorFormComponent) => [
  {
    field: "",
    header: "",
    headerCheckboxSelection: true,
    checkboxSelection: true,
  },
  {
    headerName: "LCD Set",
    field: "lcdset",
    cellRenderer: (params: ICellRendererParams) => {
      if (params.value) {
        return params.value;
      }

      return "—";
    },
  },
  {
    headerName: "LCD Type",
    cellRenderer: (params: ICellRendererParams) => {
      if (params.value) {
        return params.value;
      }

      return "—";
    },
    field: "lcdtype",
  },
  {
    headerName: "Code Set",
    cellRenderer: (params: ICellRendererParams) => {
      if (params.value) {
        return params.value;
      }

      return "—";
    },
    field: "codeset",
  },
];
